export default __webpack_public_path__ + "static/media/canvasAndFramedA3Wood.9a93b0f0.jpg";